//import ScrollEffect from "./ScrollEffect";
import initSwiper from "./InitSwiper";

export default function() {
    initSwiper();
    //ScrollEffect();
}
